/**
 * After a redeploy, an open tab may ask for page chunks that no longer exist (hashed file names change).
 * Reload once to fetch the new index.html; the guard prevents a reload loop if the chunk is really broken.
 */
const KEY = 'velostube.chunkReloadAt';

export function isChunkLoadError(err: unknown): boolean {
  const msg = err instanceof Error ? err.message : String(err);
  return /dynamically imported module|Importing a module script failed|error loading dynamically imported/i.test(
    msg,
  );
}

/** Returns true if a reload was triggered. */
export function reloadForStaleChunk(): boolean {
  try {
    const last = Number(sessionStorage.getItem(KEY) ?? 0);
    if (Date.now() - last < 30_000) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    return false;
  }
  window.location.reload();
  return true;
}

export function installStaleChunkReload(): void {
  window.addEventListener('vite:preloadError', (e) => {
    if (reloadForStaleChunk()) e.preventDefault();
  });
}
